import { _breakP } from './utils.js';

/**
 * moreBtn の追従挙動。
 * moreBtn を内包する section の上部が（PC:画面上端 / SP:画面中央）に来たら、
 * moreBtn を画面右下に position:fixed で追従させる（opacity 0→1）。
 * 本来の位置（親 __btn スロット）に達したら relative に戻す（ドッキング）。逆スクロールも対応。
 */
export default class MoreBtn {
  constructor() {
    this.bottomRem = 3.2;          // PC：追従(fixed)時の bottom（rem。CSS と一致させる）
    this.bottomRemSp = 10;         // SP：追従(fixed)時の bottom（rem。CSS と一致させる）
    this.spThresholdRatio = 0.5;   // SP：section 上部が画面中央（vh*この割合）に来たら発火
    this.items = [];

    document.querySelectorAll('.js-moreBtn').forEach((btn) => {
      const section = btn.closest('section');
      const slot = btn.parentElement;
      if (section && slot) this.items.push({ btn, section, slot, height: 0 });
    });
    if (!this.items.length) return;

    this.ticking = false;
    this.requestUpdate = this.requestUpdate.bind(this);
    this.onResize = this.onResize.bind(this);

    this.measure();
    this.update();
    window.addEventListener('scroll', this.requestUpdate, { passive: true });
    window.addEventListener('lenis-scroll', this.requestUpdate);
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  measure() {
    // fixed 化でスロットが潰れて高さが変わらないよう、ボタンの高さ分を確保。
    // あわせて「本来の位置（自然な状態）の右端」を計測し、追従時の right に使う。
    const vw = document.documentElement.clientWidth;
    this.items.forEach((item) => {
      // 自然位置（relative・本来の right）で計測：高さ確保＋本来の右端を取得。
      item.btn.classList.add('is-docked');
      item.btn.style.right = '';
      item.height = item.btn.offsetHeight;
      const rect = item.btn.getBoundingClientRect();
      // 画面右端からボタン右端までの距離（＝本来位置と同じ right 量）
      item.rightOffset = Math.max(0, vw - rect.right);
      item.slot.style.minHeight = `${item.height}px`;
      item.sectionHeight = item.section.offsetHeight;
      item.btn.classList.remove('is-docked');
    });
  }

  requestUpdate() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  onResize() {
    this.measure();
    this.update();
  }

  update() {
    const vh = window.innerHeight;
    const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
    const bottomPx = (_breakP.SP ? this.bottomRemSp : this.bottomRem) * remPx;

    this.items.forEach((item) => {
      // 画面高さが section 高さ以上なら追従しない＝常に本来位置（relative）
      if (vh >= item.sectionHeight) {
        item.btn.style.right = '';
        item.btn.classList.add('is-docked');
        item.btn.classList.remove('is-hidden');
        return;
      }

      const sectionTop = item.section.getBoundingClientRect().top;
      const slotTop = item.slot.getBoundingClientRect().top;
      // 追従時のボタン上端の位置（画面右下に固定したときの top）
      const floatingTop = vh - bottomPx - item.height;
      // SP、または画面高さが section 高さの半分を越える場合は「section 上部が画面中央」で発火。
      // それ以外（PC で section が十分高い）は「section 上部が画面上端」で発火。
      const threshold = (_breakP.SP || vh > item.sectionHeight / 2) ? vh * this.spThresholdRatio : 0;
      const entered = sectionTop <= threshold;
      // 本来の位置（スロット）が追従位置まで上がってきたらドッキング
      const docked = slotTop <= floatingTop;

      if (!entered) {
        // 未発火：fixed のまま非表示
        item.btn.style.right = `${item.rightOffset}px`;
        item.btn.classList.add('is-hidden');
        item.btn.classList.remove('is-docked');
      } else if (!docked) {
        // 追従中（基本 fixed）：right は本来の位置（自然な右端）と同じ量
        item.btn.style.right = `${item.rightOffset}px`;
        item.btn.classList.remove('is-docked', 'is-hidden');
      } else {
        // 元の位置に到達：relative にドッキング（right はクリアして本来位置へ）
        item.btn.style.right = '';
        item.btn.classList.add('is-docked');
        item.btn.classList.remove('is-hidden');
      }
    });
  }
}
